import axios from 'axios';
import { setAlert } from './alert';
import {
  GET_ARTICLES,
  GET_ARTICLE,
  ADD_ARTICLE,
  DELETE_ARTICLE,
  ARTICLE_ERROR,
  CLEAR_ARTICLES,
  CLEAR_ARTICLE
} from './types';

// Get my articles
export const getMyArticles = () => async dispatch => {
  try {
    const res = await axios.get('/api/articles/my-articles');

    dispatch({
      type: GET_ARTICLES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get articles
export const getArticles = () => async dispatch => {
  try {
    const res = await axios.get('/api/articles');

    dispatch({
      type: GET_ARTICLES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get article by ID
export const getArticleById = id => async dispatch => {
  try {
    const res = await axios.get(`/api/articles/${id}`);

    dispatch({
      type: GET_ARTICLE,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: {
        msg: err.response.statusText,
        status: err.response.status
      }
    });
  }
};

// Get articles by user ID
export const getArticlesByUser = userId => async dispatch => {
  try {
    const res = await axios.get(`/api/articles/user/${userId}`);

    dispatch({
      try: GET_ARTICLES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.statis }
    });
  }
};
